import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="App">
      <header className="App-header">
        <a href="https://ceo.ca">
          <img
            src={require("../../assets/logo.png")}
            alt="logo"
            className="logo"
          />
        </a>
      </header>
      <Outlet />
      <footer className="App-footer">
        <a href="https://ceo.ca">
          <img
            src={require("../../assets/logo.png")}
            alt="logo"
            className="logo-footer"
          />
        </a>
        <a href="/" style={{ textDecoration: "none" }}>
          <h4 className="footer-link">Help Desk</h4>
        </a>
        <a href="/member-advisory-board" style={{ textDecoration: "none" }}>
          <h4 className="footer-link">Member Advisory Board</h4>
        </a>
        <a href="https://ceo.ca/feedback" className="question-link">
          Have a question that we're missing?
        </a>
        <p className="footer-text">© {new Date().getFullYear()} - CEO.CA Technologies Ltd.</p>
      </footer>
    </div>
  );
};

export default Layout;
